import React from "react";
import { animateSpinIcon } from "../../assets/icons/SvgIconList";

const BufferLoder = () => {
  return (
    <div>
      <div className="size-20 text-accent">{animateSpinIcon}</div>
    </div>
  );
};

export default BufferLoder;
